// 先搜助手：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 助手界面
export const ui = Object.freeze({
  "pcAi.preparingAnswer": "正在準備回答…",
  "pcAi.history": "會話歷史",
  "pcAi.newChat": "新對話",
  "pcAi.historyLoading": "歷史載入中...",
  "pcAi.noHistory": "暫無歷史",
  "pcAi.delete": "刪除",
  "pcAi.platformLoading": "平台用戶載入中...",
  "pcAi.signingIn": "先搜AI自動登入中...",
  "pcAi.brand": "先搜AI",
  "pcAi.missingIdentity": "平台用戶字段缺失",
  "pcAi.missingIdentityHint": "當前用戶缺少可用於登入 AI 助手的用戶標識。",
  "pcAi.noModels": "無可用模型",
  "pcAi.reload": "重新載入",
  "pcAi.welcome": "先搜 AI 為您服務",
  "pcAi.trace": "AI 執行過程",
  "pcAi.traceFallback": "執行過程",
  "pcAi.sourceCount": "候選來源 {count} 個",
  "pcAi.sourceHint": "候選資料已送入模型上下文，不代表最終引用",
  "pcAi.copy": "複製訊息",
  "pcAi.generating": "生成中",
  "pcAi.retry": "重試",
  "pcAi.placeholder": "有什麼我能幫您的嗎？",
  "pcAi.addAttachment": "添加附件",
  "pcAi.uploadAttachment": "上傳圖片或 PDF",
  "pcAi.stop": "停止生成",
  "pcAi.send": "發送",
  "pcAi.saving": "正在儲存會話...",
  "pcAi.userLoadFailed": "平台用戶資料獲取失敗",
  "pcAi.recommend1": "深圳先搜科技有限公司在哪裏？",
  "pcAi.recommend2": "幫我分析這個晶片型號是否可以替代",
  "pcAi.recommend3": "怎樣判斷一個料號屬於哪個品牌？",
  "pcAi.recommend4": "推薦幾款常用的國產替代晶片",
  "pcAi.recommend5": "如何根據參數選擇合適的電子元器件？",
  "pcAi.recommend6": "幫我整理一份元器件採購詢價需求",
  "pcAi.recommend7": "電子元器件選型時需要關注哪些參數？",
  "pcAi.recommend8": "如何識別並修正不規範的元器件料號？",
  "pcAi.recommend9": "幫我比較兩個晶片型號的主要區別",
  "pcAi.recommend10": "採購電子元器件時如何降低缺貨風險？",
  "pcAi.recommend11": "如何判斷不同封裝型號能否通用？",
  "pcAi.recommend12": "幫我解釋常見晶片參數的含義",
});

// 手机端业务流程：固定界面文案。
export const mobileWorkflow = Object.freeze({
  "mobileAi.loginContinue": "登入後繼續使用先搜 AI",
  "mobileAi.freeLimitReached":
    "您已進行了多次搜尋。為便於儲存本次對話並繼續使用先搜 AI，建議您先登入。",
  "mobileAi.loginBenefits": "登入後可儲存對話記錄，並使用完整的先搜AI功能。",
});

export const speechUi = Object.freeze({
  "speechUi.voiceListFailed": "聲音清單載入失敗",
  "speechUi.stopVoicePreview": "停止試聽",
  "speechUi.previewVoice": "試聽聲音",
});

export const sharedFlowUi = Object.freeze({
  "aiFeedback.userLoadTimeout": "用戶資料載入逾時，請點擊重試。",
  "aiFeedback.searchGuestQuotaExceeded": "您已進行了多次搜尋，建議您登入後繼續使用先搜 AI。",
  "aiFeedback.searchGuestLoading": "正在搜尋…",
  "aiFeedback.searchGuestFailed": "先搜 AI 暫不可用，請稍後重試。",

  "aiFeedback.renameFailed": "對話名稱修改失敗",
  "aiFeedback.clearTemporaryChat": "清空臨時對話",
  "aiFeedback.guest": "訪客",
  "aiFeedback.clearTemporaryChatHint":
    "訪客臨時對話清空後無法復原，剩餘提問次數不會重設。",
  "aiFeedback.deleteConversationConfirm": "確定刪除「{name}」嗎？",
});

export const messages = Object.freeze({
  ...sharedFlowUi,
  ...speechUi,
  ...mobileWorkflow,
  ...ui,
});
